export default __webpack_public_path__ + "static/media/Group 10384.03ded3c8.svg";